import { ReactNode } from "react";
import { BananaImage } from "../assets/banana-image";
import { KlingImage } from "../assets/kling-image";
import { SeedreamImage } from "../assets/seedream-image";
import { SoraImage } from "../assets/sora-image";

// 视频模型
export const SORA2 = 'sora2'; // 废除
export const SORA2_PRO = 'sora2-pro'; // 废除
export const KLING_V26_PRO = 'kling-v2.6-pro';

// 图片模型
export const NANO_BANANA = 'gemini-2.5-flash-image';
export const NANO_BANANA_PRO = 'gemini-3-pro-image-preview';
export const SEEDREAM_V45 = 'doubao-seedream-4-5-251128'

interface ModelOption {
  /** 模型名称 */
  label: string;
  /** 模型值 */
  value: string;
  /** 模型类型 */
  type: 'video' | 'image';
  /** 最大图片数量（也可以是首帧） */
  maxImages?: number;
  /** 最大输入文件大小（字节） */
  maxInputFileSize: number;
  /** 最大图片宽度（像素） */
  maxImageWidth?: number;
  /** 最大图片高度（像素） */
  maxImageHeight?: number;
  /** 接受的输入文件类型 */
  acceptedInputFileTypes: string;
  /** 是否首尾帧图片 */
  isFontEndFrameImage?: boolean;
  /** 尾帧图片数量 */
  endMaxFrameImages?: number;
  /** 图标 */
  icon?: ReactNode;
}

// 视频模型选项
export const videoModelOptions = (): ModelOption[] => {
  return [
    // {
    //   label: 'Sora 2',
    //   value: SORA2,
    //   type: 'video',
    //   maxImages: 1,
    //   // 限制上传文件大小
    //   maxInputFileSize: 10 * 1024 * 1024, // 10MB
    //   // 支持的文件格式
    //   acceptedInputFileTypes: 'image/jpeg,image/png',
    //   icon: <SoraImage className="size-9" />,
    // },
    // {
    //   label: 'Sora 2-Pro',
    //   value: SORA2_PRO,
    //   type: 'video',
    //   maxImages: 1,
    //   maxInputFileSize: 10 * 1024 * 1024, // 10MB
    //   acceptedInputFileTypes: 'image/jpeg,image/png',
    //   icon: <SoraImage className="size-9" />,
    // },
    {
      label: 'M1-KL',
      value: KLING_V26_PRO,
      type: 'video',
      maxImages: 1, // 也代表首帧
      isFontEndFrameImage: true, // 是否首尾帧图片
      endMaxFrameImages: 1, // 尾帧图片数量,
      maxInputFileSize: 10 * 1024 * 1024, // 10MB
      acceptedInputFileTypes: 'image/jpeg,image/png',
      icon: <KlingImage className="size-9" />,
    }
  ]
};

// 图片模型选项
export const imageModelOptions = ({
  banana = {},
  bananaPro = {},
  seedream = {}
}: {
  banana?: { disabled?: boolean, disabledText?: string },
  bananaPro?: { disabled?: boolean },
  seedream?: { disabled?: boolean, disabledText?: string }
} = {}): ModelOption[] => {
  return [
    {
      label: 'Nano banana',
      value: NANO_BANANA,
      type: 'image',
      icon: <BananaImage className="size-9" />,
      maxImages: 3,
      maxInputFileSize: 7 * 1024 * 1024, // 7MB
      acceptedInputFileTypes: 'image/jpeg,image/png',
      ...banana,
    },
    {
      label: 'Nano banana pro',
      value: NANO_BANANA_PRO,
      type: 'image',
      icon: <BananaImage className="size-9" />,
      maxImages: 10,
      maxInputFileSize: 7 * 1024 * 1024, // 7MB
      acceptedInputFileTypes: 'image/jpeg,image/png',
      ...bananaPro,
    },
    {
      label: 'M1-SD',
      value: SEEDREAM_V45,
      type: 'image',
      icon: <SeedreamImage className="size-9" />,
      maxImages: 10,
      maxInputFileSize: 10 * 1024 * 1024, // 10MB
      maxImageWidth: 4090,
      maxImageHeight: 4090,
      acceptedInputFileTypes: 'image/jpeg,image/png',
      ...seedream,
    }
  ];
};

// 根据模型值，获取模型项
export const getModelOptionByValue = (model: string) => {
  const options = [...videoModelOptions(), ...imageModelOptions()];
  return options.find((item) => item.value === model);
}

// 获取模型名称
export const getModelNameByValue = (model: string) => {
  const modelOption = getModelOptionByValue(model);
  return modelOption?.label || model;
}

// 获取模型类型
export const getModelTypeByValue = (model: string) => {
  const modelOption = getModelOptionByValue(model);
  return modelOption?.type;
}